<script setup lang="ts">
const { step } = useOfferteWizard()

const items = [
  { n: 1, label: 'Pakket' },
  { n: 2, label: 'Gegevens' },
  { n: 3, label: 'Woning' },
  { n: 4, label: 'Planning' },
  { n: 5, label: 'Overzicht' },
] as const
</script>

<template>
  <ol class="pa-wizard__stepper">
    <li
        v-for="item in items"
        :key="item.n"
        class="pa-wizard__step"
        :class="{
          'pa-wizard__step--active': item.n === step,
          'pa-wizard__step--done': item.n < step,
        }"
    >
      <span class="pa-wizard__step-dot">
        <svg
            v-if="item.n < step"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
        <span v-else>{{ item.n }}</span>
      </span>
      <span class="pa-wizard__step-label">{{ item.label }}</span>
    </li>
  </ol>
</template>
